import {
  useOrganizationsServiceOrganizationsTeamsCreate,
  useOrganizationsServiceOrganizationsTeamsListKey
} from '@organization/api/queries'
import { TeamModify } from '@organization/api/requests'
import { messages } from '@organization/app-constants'
import { TitleActionButton } from '@organization/components'
import { useInvalidateQueries, useQueryUpdate } from '@shared/hooks'
import { showApiErrors } from '@shared/utils'
import { App, Button, Flex } from 'antd'
import { Profile2User } from 'iconsax-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { TeamForm } from '../Team'
import { TeamsTable } from '../Teams'

export const TeamsTableContainer = () => {
  const { t } = useTranslation()
  const { params, updateQuery } = useQueryUpdate()
  const { invalidateQueries } = useInvalidateQueries()
  const [isOpen, setIsOpen] = useState(false)
  const [parentId, setParentId] = useState<null | number>(null)
  const { message } = App.useApp()

  const { mutate, isPending } = useOrganizationsServiceOrganizationsTeamsCreate(
    {
      onSuccess: () => {
        message.success(messages.teamCreated)
        setIsOpen(false)
        setParentId(null)
        invalidateQueries([useOrganizationsServiceOrganizationsTeamsListKey])
      },
      onError: (e) => showApiErrors(e)
    }
  )

  return (
    <Flex vertical gap={20}>
      <TitleActionButton
        title={`${t('users.my_teams')}`}
        onSearch={(search) => updateQuery({ search })}
        searchValue={params.search}
        renderActionButton={() => (
          <Button
            type="primary"
            onClick={() => setIsOpen(true)}
            icon={<Profile2User size={14} />}
          >
            {t('users.add_team')}
          </Button>
        )}
      />

      <TeamsTable
        addTeamBtn={(id) => (
          <Button
            type="primary"
            onClick={() => {
              setIsOpen(true)
              setParentId(id)
            }}
            icon={<Profile2User size={14} />}
            block
          >
            {t('users.add_team')}
          </Button>
        )}
      />

      {isOpen && (
        <TeamForm
          key="add-team"
          title={t('users.add_new_team')}
          okText={t('button.add')}
          parent={parentId}
          onSubmit={(values) => {
            mutate({ requestBody: values as TeamModify })
          }}
          isLoading={isPending}
          onCancel={() => {
            setIsOpen(false)
            setParentId(null)
          }}
        />
      )}
    </Flex>
  )
}
